import React, { FC } from 'react'
import styles from './VideoPlayer.module.scss'
import useVideoPlayer from './useVideoPlayer'
import classNames from 'classnames'

type Props = {
  file: string
  styleOverride?: string
  onVideoPlay?: () => void
}

const VideoPlayerPDP: FC<Props> = (props: Props) => {
  const { file, styleOverride } = props

  const doNothing = () => {}
  const onVideoPlay = props.onVideoPlay ?? doNothing
  // Use Custom Controls - if your not gonna have BROWSER controls
  const videoPlayer = useVideoPlayer({ file, customControls: true })
  const { videoRef, videoHeight = 0, videoWidth = 0, videoAspectRatio = 'auto' } = videoPlayer

  return (
    <div className={classNames(styles.videoPlayer, styleOverride ?? null)}>
      <video
        onPlay={onVideoPlay}
        ref={videoRef}
        preload='auto'
        autoPlay
        loop
        muted
        width={videoHeight}
        height={videoWidth}
        style={{ aspectRatio: videoAspectRatio }}
      >
        <source src={file} />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default VideoPlayerPDP
